// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'polysans', 'polysans Fallback'"},"className":"__className_fe1881"};